import { ActionType, matcher, MatchType } from "@cdv/jazz-ui";
import View from "../ui/View";
import Content from "./Content";
import { Resource } from "../utils";
import ContentShow from "./ContentShow";

export default matcher({ resource: Resource.Page })
  .set(MatchType.View, View)
  .set(MatchType.Content, Content, { action: ActionType.INDEX })
  .set(MatchType.Content, ContentShow, { action: ActionType.SHOW })
  .entries();
